/* eslint-disable @next/next/no-img-element */
"use client";

import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaPlay } from "react-icons/fa";
import AskLocalFormModal from "@/components/HomePage/GetFreeConciergeAccess/page";
import GoogleReview from "./googlereview";

const Hero: React.FC = () => {
  const [isVideoOpen, setIsVideoOpen] = useState(false);
  const [isFormOpen, setIsFormOpen] = useState(false);

useEffect(() => {
  const openConciergeModal = () => {
    setIsFormOpen(true);
  };

  window.addEventListener("openAskLocalConcierge", openConciergeModal);

  return () => {
    window.removeEventListener("openAskLocalConcierge", openConciergeModal);
  };
}, []);

  return (
    <>
      {/* HERO SECTION */}
      <section className="relative w-full min-h-screen bg-linear-to-br from-blue-50 via-white to-blue-100 overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0 bg-[url('/IMG_2420.JPEG')] bg-cover bg-center opacity-45 mix-blend-normal"></div>

        {/* Decorative Right Shape */}
        <div
          className="absolute right-0 top-0  
          h-[700px] w-[500px]         
          sm:h-[400px] sm:w-[400px]   
          md:h-[500px] md:w-[550px]   
          lg:h-full lg:w-[700px]      
          bg-no-repeat bg-right opacity-100 mix-blend-normal"
          style={{
            backgroundImage: "url('/Group.png')",
            backgroundSize: "contain",
          }}
        ></div>

        {/* Main Content */}
        <div className="relative z-10 max-w-[1200px] mx-auto px-6 py-20 lg:py-40 flex flex-col lg:flex-row items-center justify-between">
          {/* LEFT TEXT */}
          <div className="text-center lg:text-left max-w-xl lg:max-w-[700px]">
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl judson-regular text-[#000000] mb-6 leading-tight">
              Real estate doesn’t have to feel chaotic.{" "}
              <br className="hidden sm:block" />
            </h1>

            <p className="inter-semibold text-gray-500 mb-8 leading-relaxed text-base sm:text-lg md:text-xl">
              AskLocal is your private, secure concierge that helps you build
              the right team,get clear answers, and move forward with confidence
               from first question to closing.
              <br className="hidden md:block" />
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4 mt-6">
              {/* Primary Button */}
              <button
                onClick={() => setIsFormOpen(true)}
                className="bg-[#EB9C2C] text-white cursor-pointer px-8 py-3 rounded-xl text-base sm:text-lg font-semibold hover:bg-[#227abb] transition-all duration-300 shadow-md w-full sm:w-auto"
              >
                Start Your Free AskLocal Concierge
              </button>

              {/* Secondary Button with Icon */}
              <button
                onClick={() => setIsVideoOpen(true)}
                className="flex items-center justify-center cursor-pointer gap-2 bg-transparent border border-black text-black px-5 py-3 rounded-xl inter-semibold font-semibold hover:border-none hover:text-white hover:bg-[#227abb] transition-all duration-300 shadow-md w-full sm:w-auto"
              >
                <FaPlay className="text-sm text-white bg-black rounded-full p-2 w-7 h-7" />
                <span>See How It Works</span>
              </button>
            </div>
          </div>

          {/* RIGHT LOGO */}
          <div className="mt-12 lg:mt-0 relative z-20 flex justify-center">
            <img
              src="/asklocal_logo.svg"
              alt="Asklocal Logo"
              className="w-[400px] sm:w-[300px] md:w-[350px] lg:w-[400px] h-auto object-contain drop-shadow-xl"
            />
          </div>
        </div>

        {/* Trusted Companies Section */}
        <section className="w-full text-[#000000]  px-4 overflow-hidden">
          <div className="max-w-7xl  mx-auto text-center">
            {/* Auto-scrolling logos */}
            <div className="mb-10">
              <GoogleReview />
            </div>
          </div>
        </section>
      </section>
      {/* vedio */}
      <AnimatePresence>
        {isVideoOpen && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/80 flex items-center justify-center z-9999 backdrop-blur-sm px-4"
          >
            <div className="relative w-full max-w-4xl h-190 bg-black rounded-2xl overflow-hidden shadow-2xl">
              {/* ❌ Close Button */}
              <button
                onClick={() => setIsVideoOpen(false)}
                className="absolute top-3 right-3 z-50 bg-black/60 text-white w-9 h-9 flex items-center justify-center rounded-full text-2xl font-bold hover:bg-black/80 active:scale-95 transition-all"
              >
                ×
              </button>

              {/* 🎞️ Video */}
              <video
                className="w-full h-auto max-h-[80vh] object-contain"
                controls
                autoPlay
                src="/Home_page.mp4"
              />
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* 💡 Get Started Modal (Concierge Form) */}
      <AskLocalFormModal
        isOpen={isFormOpen}
        onClose={() => setIsFormOpen(false)}
      />
    </>
  );
};

export default Hero;
